import { render, staticRenderFns } from "./DocumentSelector.vue?vue&type=template&id=a140c896"
import script from "./DocumentSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentSelector.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DocumentSelector.vue?vue&type=style&index=0&id=a140c896&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports